module.exports = __webpack_public_path__ + "img/blood-over-bright-haven.5ef02b7c.png";